import {
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
  Box
} from '@mui/material'
import { Theme, useTheme } from '@mui/material/styles'

const styles = {
  codeBox: (theme: Theme) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.05)',
    padding: 2,
    borderRadius: 1,
    marginTop: 2,
    border: 'solid 1px',
    borderColor: 'divider'
  })
}

export const EmailCaptureWidget = () => {
  const theme = useTheme()

  return (
    <Card>
      <CardHeader
        title="Email Capture Widget"
        data-testid="email-capture-widget-header"
      />
      <CardContent>
        <Typography variant="body1" gutterBottom>
          A simple React component to capture emails from your sites and add
          into the Deals Newsletter
        </Typography>

        <CardMedia sx={{ marginTop: '15px', marginBottom: '15px' }}>
          <img src="/assets/images/email-capture.jpg" alt="Email Capture" />
        </CardMedia>

        <Typography variant="h6" gutterBottom>
          Install JavaScript Snippet
        </Typography>

        <Typography variant="body1" gutterBottom>
          Copy and paste this JavaScript snippet before the closing{' '}
          <code>&lt;/head&gt;</code> tag of your site.
        </Typography>

        <Typography variant="body2" gutterBottom>
          <strong>Please get the pubID from your Account Manager.</strong>
        </Typography>

        <Box component="div" sx={styles.codeBox(theme)}>
          <Typography variant="body2" component="div">
            &lt;script&gt;
            <br />
            var scSettings = &#123;
            <br />
            &nbsp;&nbsp;pubID: "CHANGEME - Get your pubID from your Account
            Manager",
            <br />
            &nbsp;&nbsp;headerCopy: "Score Exclusive Deals & Discounts",
            <br />
            &nbsp;&nbsp;subHeaderCopy: "The hottest new products delivered
            daily",
            <br />
            &nbsp;&nbsp;confirmationHeader: "You're in!",
            <br />
            &nbsp;&nbsp;confirmationSubHeaderCopy: "Check your inbox tomorrow
            for amazing new deals",
            <br />
            &nbsp;&nbsp;styles: &#123;
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;buttonColor: "#0cb3fa",
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;fontFamily: "Open Sans, Arial, sans-serif",
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;backgroundColor: "#f5f5f5"
            <br />
            &nbsp;&nbsp;&#125;
            <br />
            &#125;
            <br />
            &lt;/script&gt;
            <br />
            &lt;script type="text/javascript"
            src="https://widgets.stackcommerce.com/sc.js"&gt;&lt;/script&gt;
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}
